import { Component, computed, inject, Signal } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { PreferencesService } from '@core/components/preferences/services/preferences.service';
import { TranslatePipe } from '@ngx-translate/core';
import { DropdownCloseDirective } from '@shared/directives/dropdown-close.directive';

import { ButtonComponent } from '@ctti-dev/ng-gencat';
import { DropdownComponent } from '@shared/components/dropdown/dropdown.component';

import { Button } from '@shared/models/button.model';
import { Header } from '../../models/backoffice-header.model';

import {
  HEADER_CONFIG,
  USER_HEADER_BUTTON,
} from '../../configurations/header.config';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { UserService } from '@core/services/user.service';
import { DatePipe } from '@angular/common';
import { UserProfileContext } from '@core/models/user.model';
import { ButtonConfigDirective } from '@shared/directives/button-config.directive';
import { TERTIARY_BUTTON } from '@shared/utils/utils.config';

@Component({
  selector: 'app-header-user',
  standalone: true,
  imports: [
    NgbDropdownModule,
    DropdownCloseDirective,
    TranslatePipe,
    DropdownComponent,
    ButtonComponent,
    DatePipe,
    ButtonConfigDirective,
  ],
  templateUrl: './header-user.component.html',
  styleUrl: './header-user.component.scss',
})
export class HeaderUserComponent {
  readonly gencatHeaderConfig: Header = HEADER_CONFIG;
  readonly userHeaderButton: Partial<Button> = USER_HEADER_BUTTON;
  readonly tertiaryButton = TERTIARY_BUTTON;

  readonly currentLanguageSignal: Signal<string> = computed(() =>
    this._languagePreferencesService.currentLanguageSignal(),
  );

  private readonly _languagePreferencesService = inject(PreferencesService);
  private readonly _router = inject(Router);
  private readonly _authService = inject(AuthService);
  private readonly _userService = inject(UserService);

  readonly userData: Signal<UserProfileContext> = this._userService.userData;

  changePreferences(): void {
    this._router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this._router.navigateByUrl('home/preferences'));
  }

  closeSessionFromBanner(): void {
    this._authService.logout();
  }

  getUserRolesLabel(): string {
    return this._userService.getUserRolesLabels();
  }
}
